jQuery(function() {
    initMobileNav();
    initSlickCarousel();
    initStickyScrollBlock();
    initBgParallax();
    initFocusActiveClass();
    initOpenClose();
    initInViewport();
    initCookieAlert();
});

$(function() {
    $('form').submit(function(e) {
        e.preventDefault();

        var $form = $(this);
        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize()
        }).done(function() {
            var $message = $('<div>', {
                class: 'form-send-message',
                text: 'Nachricht gesendet!'
            });
            $form.parent().append($message);
            $form[0].reset();
            setTimeout(function() {
                $message.fadeOut('slow', function() {
                    $(this).remove(); // удаляем сообщение из DOM-дерева
                });
            }, 3500);
            $('.form-row').removeClass('input-active');
        }).fail(function() {
            var $message = $('<div>', {
                class: 'form-send-message',
                text: 'Fehler beim Senden der Nachricht.'
            });
            $form.parent().append($message);
            setTimeout(function() {
                $message.fadeOut('slow', function() {
                    $(this).remove(); // удаляем сообщение из DOM-дерева
                });
            }, 3500);
            $('.form-row').removeClass('input-active');
        });
    });
});

// simplebox init
$('.simplebox').simplebox({
    duration: 300,
    linkClose: '.close, .btn-close, .close-to-top',
    onOpen: function(obj){
        var body = $(document.body);
        body.addClass('opened-modal');
    },
    onClose: function(obj){
        var body = $(document.body);
        body.removeClass('opened-modal');
    },
    afterClose: function(obj) {
        $('.close-to-top').click(function() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }
});

// mobile menu init
function initMobileNav() {
    jQuery('body').mobileNav({
        menuActiveClass: 'nav-active',
        menuOpener: '.nav-opener',
        hideOnClickOutside: true,
    });
}

// slick init
function initSlickCarousel() {
    jQuery('.main-slider').slick({
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        infinite: true,
        speed: 400,
        fade: true,
    });
}

// initialize fixed blocks on scroll
function initStickyScrollBlock() {
    jQuery('#header').stickyScrollBlock({
        setBoxHeight: false,
        activeClass: 'sticky-header',
        positionType: 'fixed'
    });
}

// initialize bg parallax
function initBgParallax() {
    jQuery('.bg-parallax').parallaxBlock({
        image: 'img',
        fallbackClass: 'is-touch-device'
    });
}

// initialize cookie alert
function initCookieAlert() {
    function checkConsentAndShowBanner() {
        if (!sessionStorage.getItem('cookiesAccepted')) {
            $('#cookie-banner').show().addClass('visible');
            $('body').addClass('opened-modal');
        } else {
            $('#cookie-banner').hide();
            $('body').removeClass('opened-modal');
        }
    }

    $('#accept-cookies').click(function () {
        sessionStorage.setItem('cookiesAccepted', 'true');
        $('#cookie-banner').hide();
        $('body').removeClass('opened-modal');
    });

    $('#reject-cookies').click(function () {
        window['ga-disable-G-DZNDTKH48'] = true;
        $('#cookie-banner').hide().removeClass('visible');
        $('body').removeClass('opened-modal');
    });

    $(document).ready(function () {
        checkConsentAndShowBanner();
    });
}


// add class when element is in focus and not empty
function  initFocusActiveClass() {
    jQuery('.form-row').addFocusActiveClass({
        focusClass: 'input-focused',
        activeClass: 'input-active',
        element: 'input, textarea'
    });
}

// open-close init
function initOpenClose() {
    jQuery('.popup-tel-form').openClose({
        activeClass: 'active',
        opener: '.tel-form-opener',
        slider: '.tel-form',
        animSpeed: 400,
        hideOnClickOutside: true,
        effect: 'fade',
        btnClose: '.close-slide'
    });
}

;(function(w) {
    w.addEventListener('load', function() {
        var loader = document.querySelector('body');

        if (loader) {
            setTimeout(function() {
                loader.classList.add('loaded');
            }, 300);
        }
    });
}(window));

// block in view
function initInViewport() {
    jQuery('.viewport-block').itemInViewport({
        activeClass: 'in-viewport',
        visibleMode: 2
    });
}
